import { FunctionComponent } from "react";
import Stack from "@mui/material/Stack";
import { IconButton, Tooltip } from "@mui/material";
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';

interface IProps {
    f: (id: string) => void;
    id: string;
}

const CopyAction: FunctionComponent<IProps> = ({ f, id }) => {
    return (
        <Stack width='100%' alignItems='center'>
            <Tooltip title="Copy">
                <IconButton onClick={() => f(id)}>
                    <ContentCopyOutlinedIcon />
                </IconButton>
            </Tooltip>
        </Stack>
    );
};

export default CopyAction;